import { lazy } from "react";
import { authRoles } from "app/auth/authRoles";
import ActiveClientGuard from "./ActiveClientGuard";

const DashboardV1 = lazy(() => import("./dashboard1/Dashboard1"));
const DashboardV2 = lazy(() => import("./dashboard2/Dashboard2"));

const dashboardRoutes = [
  {
    path: "/dashboard/v1",
    element: (
      <ActiveClientGuard>
        <DashboardV1 />
      </ActiveClientGuard>
    ),
    auth: authRoles.admin,
  },
  {
    path: "/dashboard/v2",
    element: (
      <ActiveClientGuard>
        <DashboardV2 />
      </ActiveClientGuard>
    ),
    auth: authRoles.admin,
  }
];

export default dashboardRoutes;
